import React from 'react';
import {
  AppstoreOutlined,
  BellOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  SafetyCertificateOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { Layout } from 'antd';
import { useI18n } from '../i18n';
import { brandSemantic } from '../config/brand';

const { Sider } = Layout;

const navItems = [
  { key: 'followUps', icon: <BellOutlined />, label: 'Follow-ups' },
  { key: 'inquiries', icon: <FileSearchOutlined />, label: 'Inquiries' },
  { key: 'quotes', icon: <FileTextOutlined />, label: 'Internal Quotes' },
  { key: 'offers', icon: <ShoppingCartOutlined />, label: 'Sales Quotes' },
  { key: 'orders', icon: <ShoppingOutlined />, label: 'Orders' },
  { key: 'suppliers', icon: <ShopOutlined />, label: 'Suppliers' },
  { key: 'leads', icon: <TeamOutlined />, label: 'Customers' },
  { key: 'products', icon: <AppstoreOutlined />, label: 'Products' },
  { key: 'compliance', icon: <SafetyCertificateOutlined />, label: 'Compliance' },
];

export default function AppSidebar({ currentView, setCurrentView, setSelectedLead, leadProfileReturnView, orderDetailsReturn, inquiryReturnView, quoteReturnView }) {
  const { t } = useI18n();
  const activeKey = currentView === 'leadProfile'
    ? leadProfileReturnView
    : currentView === 'contacts'
      ? 'leads'
    : currentView === 'supplierProfile'
      ? 'suppliers'
    : currentView === 'inquiryDetail'
      ? (inquiryReturnView || 'inquiries')
    : currentView === 'quoteDetail'
      ? (quoteReturnView || 'quotes')
    : currentView === 'orderDetails'
      ? orderDetailsReturn?.view === 'leadProfile'
        ? leadProfileReturnView
        : orderDetailsReturn?.view === 'supplierProfile'
          ? 'suppliers'
        : (orderDetailsReturn?.view || 'offers')
      : currentView;

  return (
    <Sider
      width={104}
      style={{
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        background: brandSemantic.sidebarBg,
        borderRight: `1px solid ${brandSemantic.sidebarBorder}`,
        display: 'flex',
        flexDirection: 'column',
      }}
      >
      <div
        style={{
          minHeight: 64,
          height: 64,
          borderBottom: `1px solid ${brandSemantic.sidebarBorder}`,
          flexShrink: 0,
          background: brandSemantic.sidebarHeaderBg,
        }}
      />
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden', padding: '12px 0' }}>
        {navItems.map(item => (
          <div
            key={item.key}
            className={`custom-sidebar-item${activeKey === item.key ? ' active' : ''}`}
            onClick={() => {
              const key = item.key;
              if (key !== currentView) setSelectedLead(null);
              setCurrentView(key);
            }}
          >
            {item.icon}
            <div className="item-label">{t(item.label)}</div>
          </div>
        ))}
      </div>
    </Sider>
  );
}
